import { IState } from 'app/cross-cutting-concerns/state-management/interfaces/IState';
import { Optional } from 'lib/types/Optional';

export const selectIsLoading = (state: IState): Optional<boolean> =>
  state.modules['terms-conditions'].termsConditions.termsConditionsForm.isLoading;

export const selectHasAgreedToCurrentTerms = (state: IState): Optional<boolean> =>
  state.modules['terms-conditions'].termsConditions.hasAgreedToCurrentTerms;
